export function Title(props: { title: string }) {
  return <h2 class="font-bold text-1rem <md:(text-0.5rem)">{props?.title}</h2>;
}
